<!--
 * @Author: zxf
 * @Date: 2022-07-20 18:18:58
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:43:50
 * @Description: 维保项目详情
-->
<template>
  <div
    class="l-page l-page--detail l-page--detail-tabs"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        维保项目详情
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面主内容：仅tabs为主内容 Start -->
    <div
      class="l-page__body l-page--detail__body"
    >
      <el-tabs
        v-model="activeName"
        type="border-card"
        class="l-page__tabs l-page__tabs--full"
      >
        <el-tab-pane
          label="项目信息"
          name="wbxm"
        >
          <view-wbxm-info
            ref="wbxm"
            type="wbxm"
          />
        </el-tab-pane>
        <el-tab-pane
          label="建筑信息"
          name="jzw"
        >
          <wbjz-list
            ref="wbjzList"
            type="wbjzList"
            :operation-show="false"
            :pagination-show="false"
          />
        </el-tab-pane>
        <el-tab-pane
          label="维保计划信息"
          name="wbjh"
        >
          <wbjh-list
            ref="wbjhList"
            type="wbjhList"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ViewWbxmInfo from './viewWbxmInfo.vue';
import WbjhList from './wbjhList.vue';
import WbjzList from '../wbjz/wbjzList.vue';
// import { xfwbglService } from '../xfwbgl.service';

export default {
  name: 'ViewWbxm',
  components: {
    ViewWbxmInfo,
    WbjhList,
    WbjzList
  },
  data () {
    return {
      loading: false, // 页面loading状态
      wbjhsjQz: [null, null], // 维保计划时间起止范围
      activeName: 'wbxm',
      jzListShow: false,
      htListShow: false,
      jhListShow: false,
      hyListShow: false,
      sbListShow: false
    };
  },
  methods: {
  },
  created () {
    if (this.$route.params.showType) {
      this.activeName = this.$route.params.showType;
    }
  },
  activated () {
    if (this.$route.params.showType) {
      this.activeName = this.$route.params.showType;
    }
  }

};
</script>
